<template>
  <div class="wrap">
    <!-- <div class="tips">订单有效期为15分钟，请在规定时间内完成支付</div> -->
    <div class="patient_info">
      <ul>
        <li>
          <label>就诊医院</label>
          <span>{{hospital}}</span>
        </li>
        <li>
          <label>就诊科室</label>
          <span>{{department}}</span>
        </li>
        <li>
          <label>就诊医生</label>
          <span>{{employee}}</span>
        </li>
        <li>
          <label>就诊时间</label>
          <span>{{applyTimes}}</span>
        </li>
        <!-- <li>
          <label>预约定金</label>
          <span>12.00元</span>
        </li> -->
        <section></section>
        <li>
          <label>患者姓名</label>
          <span>{{nickName}}</span>
        </li>
        <li>
          <label>身份证号</label>
          <span>{{idNo}}</span>
        </li>
        <li>
          <label>手机号</label>
          <span>{{mobilePhone}}</span>
        </li>
      </ul>
    </div>

    <!--<div class="mask" v-if="timeIsOver">-->
      <!--<div @click="wxClose">确定</div>-->
    <!--</div>-->

    <!-- <MaskTempToast v-if="timeIsOver" @isCancelStatus="isCancelStatus" :class="timeIsOver?'isHidden':''">支付时间已过，请重新预约支付</MaskTempToast> -->
    <!-- <BtnFixed @click.native="toPay">待支付{{minAll}}</BtnFixed> -->
    <BtnFixed @click.native="confirmApply">确认预约{{minAll}}</BtnFixed>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { order,userInfo,wechatPay } from '@/apis'
  import BtnFixed from '@/components/BtnFixed'
  import MaskTempToast from '@/components/MaskTempToast'
    export default {
      data(){
        return {
          minAll:'',
          secAll:'',
          timeIsOver:false,
          wstimes:'',
          reqIsComplete:true,
          propsData:[],
          patientDto:[],
          hospital:'',
          department:'',
          employee:'',
          applyTimes:'',
          times:'',
          nickName:'',
          idNo:'',
          mobilePhone:'',
          isCancel:false,
          hasPaySuccess:false,
          orderNo: localStorage.getItem('orderNo'),
        }
      },
      components:{BtnFixed,MaskTempToast},
      computed:mapState({
        openid: state => state.openid,
        patientId: state => state.patientId,
        patientUUID: state => state.patientUUID,
        // orderNo: state => state.orderNo,
        orderApplySuccess: state => state.orderApplySuccess,
        orderFee: state => state.orderFee,
      }),

      watch:{
        patientDto(newval){
          this.nickName = newval.nickName;
          this.idNo = this.hideCenterNum(newval.idNo);
          this.mobilePhone = this.hideCenterNum(newval.mobilePhone);
        },
        propsData(newval){
          this.hospital = newval.info.hospital.name;
          this.department = newval.info.department.name;
          this.employee = newval.info.employee.name;
        }
      },
      created(){
        this.getOrderStatus()
        this.patientInfo()
      },
      mounted(){
        //未完成支付，考虑到用户切换锁屏之类的操作，加了这个方法，刷新页面，校准倒计时
        if(!this.hasPaySuccess){
          this.visibleReload()
        }else{
          this.cancaelReload();
        }
      },
      methods:{
        wxClose(){
//          this.wx.closeWindow();
          this.$router.push({
            path:'/applyIndex'
          })
        },
        isCancelStatus(data){
          this.timeIsOver = data;
        },
        eventListener(event){
          event.preventDefault();
          if('visible'==document.visibilityState){
            window.location.reload()
          }
        },
        visibleReload(){
          document.body.addEventListener('visibilitychange', this.eventListener, false);
        },
        cancaelReload(){
          document.body.removeEventListener('visibilitychange', this.eventListener,false);
        },
        getOrderStatus(){
          this.axios.get(order.orderStatus,{
            params:{
              patientId:this.patientId,
              patientUUID:this.patientUUID
            }
          }).then((res)=>{
            if(res.status==200 && res.data.code=='000000' && res.data.data.flag==1){
              if(res.data.data.residueTime>900000){
                this.times=900000
              }else{
                this.times = res.data.data.residueTime;// 总毫秒
              }
              this.propsData = res.data.data;
              this.getApplyTimes(this.propsData.info.day,this.propsData.info.period)
              this.calTimeNow(this.times);
            }else if(res.data.data.flag==0){
              this.pushToApplyIndex()
            }else if(res.data.data.flag==2){
              this.$router.push({
                path:'/applyIndex'
              })
            }else{
              this.$toast(res.data.message)
            }

          })
        },
        patientInfo(){
          this.axios.get(userInfo.queryPatientsInfo,{
            params: {
              openId: this.openid,
            }
          }).then((res)=>{
            if(res.status==200 && res.data.code=='000000'){
              this.patientDto = res.data.data.patientDto
            }else{
              this.$toast(res.data.message)
            }

          })
        },
        pushToApplyIndex(){
          this.timeIsOver = true;
//          let times = 5000;
//          this.$toast({
//            message:'支付时间已过，请重新预约支付，5秒后将跳转',
//            duration: times
//          })
//          setTimeout(()=>{
//            this.$router.push({
//              path:'/applyIndex'
//            })
//          },times)
        },
        calTimeNow(selfTime){
          window.addEventListener("popstate", function(e) {
            WeixinJSBridge.call('closeWindow');
          }, false);
          let self = this;
          self.secAll= parseInt(selfTime/1000); //总秒
          if(self.secAll/60 > 1){
            self.minAll = (parseInt(self.secAll/60)<10?'0'+parseInt(self.secAll/60):parseInt(self.secAll/60)) + ":" + (self.secAll%60<10?'0'+self.secAll%60:self.secAll%60)
            self.wstimes = parseInt(self.secAll/60)
          } else {
            self.minAll= "00:" + (self.secAll%60<10?'0'+self.secAll%60:self.secAll%60)
            self.wstimes = 1
          }
          window.timeInterval = setInterval(function(){
            self.secAll--;
            if(self.secAll/60 > 1){
              self.minAll= (parseInt(self.secAll/60)<10?'0'+parseInt(self.secAll/60):parseInt(self.secAll/60)) + ":" + (self.secAll%60<10?'0'+self.secAll%60:self.secAll%60)
              self.wstimes = parseInt(self.secAll/60)
            } else {
              self.minAll= "00:" + (self.secAll%60<10?'0'+self.secAll%60:self.secAll%60)
              self.wstimes = 1
            }
            if(self.secAll<=0){
              // window.history.go(-1);
              WeixinJSBridge.call('closeWindow');
//              self.$toast('支付时间已过，请重新预约支付')
              // self.pushToApplyIndex()
              self.wstimes = 1
              clearInterval(window.timeInterval);
            }
          },1000)
        },
        // toPay(){
        //   this.cancaelReload();
        //   this.hasPaySuccess = true;//调用微信支付，暂时禁调reload visible方法

        //   if(this.timeIsOver){
        //     return
        //   }else{
        //     if(!this.reqIsComplete){
        //       this.$toast('请勿重复请求！')
        //       return
        //     }else{
        //       // 调用微信jdk
        //       this.reqIsComplete = false;
        //       this.wechatApi.getWechatSign(this.toWechatPrepay);
        //     }

        //   }

        // },
        // 确认预约
        confirmApply(){
          if(!this.reqIsComplete){
            this.$toast('请勿重复请求！')
            return
          }
          this.axios.put(order.orderUpdate,{
            orderNo: this.orderNo,
            status: 5
          }).then((res)=>{

            const data = res.data.data;
            const flag = data.flag;

  //          flag = 0 ;   // 记得删除，测试写死数据！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！！

            this.status = flag;
            this.$toast('确认预约成功！')
            this.reqIsComplete = true;
            this.$router.push({
              path:'/applySuccess',
              query:{code:this.propsData.info.code}
            })
          });
          // const { scheduleId, period } = this.$route.query;
          // this.axios.post(order.orderCreate,{
          //   money:this.orderFee,
          //   openId:this.openid,
          //   patientId:this.patientId,       //病人id（云鹊）
          //   patientUUID:this.patientUUID,   //病人id（外部系统）
          //   scheduleId:scheduleId,    //医生排班表ID
          //   period:period             //am/pm 时间段
          // }).then((res)=>{
          //   if(res.status==200&&res.data.code=='000000'){
          //     this.store.commit('set_order_status',true);
          //     this.store.commit('get_order_no',res.data.data.orderNo);
          //     this.$router.push({
          //       path:'/payApply',
          //       query:{
          //         patientId:this.patientId,
          //         patientUUID:this.patientUUID,
          //         orderNo:res.data.data.orderNo,
          //       }
          //     });

          //   }else{
          //     this.$toast(res.data.message)
          //   }
          // }).catch((err)=> {
          //   console.log(err);
          // });
        },
        // 请求下单调用微信支付
        toWechatPrepay(){
          this.axios.post(wechatPay.prepay,{
            goodsDesc:'云鹊医联定金',
            ip:'180.168.79.138',
            expire:this.wstimes,
            orderFee:this.orderFee,
            orderNo:this.orderNo,
            openid:this.openid
          }).then((res)=>{
            let self = this;
            if(res.status==200&&res.data.code=='000000'){
              let data=res.data.data;
              self.wx.chooseWXPay({
                timestamp: data.timeStamp,
                nonceStr: data.nonceStr,
                package: data.package,
                signType: data.signType,
                paySign: data.paySign,
                success: () =>{
//                  self.$toast('支付成功！')
                  self.reqIsComplete = true;
                  self.$router.push({
                    path:'/applySuccess',
                    query:{code:this.propsData.info.code}
                  })
                },
                fail: (err) =>{
                  self.$toast('支付失败！')
                  self.reqIsComplete = true;
                  self.wx.closeWindow();
                },
                cancel: (err) =>{
                  self.$toast('取消支付！')
                  self.reqIsComplete = true;
                  self.wx.closeWindow();
                }
              });
            }else{
              this.$toast(res.data.message)
              if(res.data.message=="appid and openid not match"){
                localStorage.clear();
                // sessionStorage.clear();
              }
            }
          }).catch((err)=>{
          })
        },
        getyyyyMMdd(date){
          let d = new Date(date);
          let curr_date = d.getDate();
          let curr_month = d.getMonth() + 1;
          let curr_year = d.getFullYear();
          String(curr_month).length < 2 ? (curr_month = "0" + curr_month): curr_month;
          String(curr_date).length < 2 ? (curr_date = "0" + curr_date): curr_date;
          let yyyyMMdd = curr_year + "-" + curr_month +"-"+ curr_date;
          return yyyyMMdd;
        },
        getApplyTimes(day,period){
          let timestr = ''+day
          timestr=timestr.substr(0,4)+'-'+timestr.substr(4,2)+'-'+timestr.substr(6,2)
          let noomn = period=='am'?'上午':'下午';
          this.applyTimes = timestr +' '+ noomn
        },
        hideCenterNum(str){
          let newStr ='';
          let typestr = typeof str;
          if(typestr !='object'){
              for(let i=0;i<str.length-6;i++){
                newStr+='*'
              }
              newStr = str.substr(0,3)+newStr+str.substr(-3)
          }
          return newStr
        }
      },

    }
</script>

<style scoped lang="scss">
  .wrap{
    position: relative;
    background:$bgfff;
    @include width_height_100();
    .tips{
      width:375px;
      height:38px;
      line-height: 38px;
      padding:0 15px;
      @include text_font('PingFangSC',12px,normal,#FD9C18,left);
      background:rgba(255,149,4,.08);
    }
    .patient_info{
      ul{
        li{
          height:45px;
          line-height: 45px;
          padding:0 15px;
          @include layout_row_root();
          @include border-bottom(1px,solid,#EEEEEE);
          label,span{
            @include layout_row();
          }
          label{
            width:90px;
            @include text_font('PingFangSC',15px,normal,#666,left);
          }
          span{
            margin-left:5px;
            @include text_font('PingFangSC',15px,normal,#333,center);
          }

        }
        div{
          padding:0 15px;
          @include text_font('PingFangSC',12px,normal,#AFAFAF,left);
        }

        section{
          width:375px;
          height:7px;
          background:#F8F8F8;
        }

      }
    }
    .isHidden{
      overflow:hidden;
    }
    /*.mask{
      position:absolute;
      left:0;
      top:0;
      z-index:100;
      width:375px;
      height:667px;
      background:rgba(0,0,0,.5);
      div{
        position: absolute;
        -webkit-transform:translate(-50%,-50%);
        transform:translate(-50%,-50%);
        left:50%;
        top:60%;
        width:145px;
        height:45px;
        line-height:45px;
        margin:30px auto 0 auto;
        background:#41B7A7;
        border-radius:24px;
        @include text_font('PingFangSC',16px,normal,#fff,center);
      }
    }*/
  }
</style>



// WEBPACK FOOTER //
// src/components/doorHelp/PayTemp.vue